import { FC } from 'react';
import { Icon } from '../../index';
import { IconName } from '../index';
import * as S from './styles';

export type BackgroundColors = 'primary99' | 'neutral95' | 'neutral99' | 'success90';
export type IconSize = 's11' | 's16' | 's20';

export const TopicIcon: FC<{
  /** External image URL. Overrides iconName if present. */
  iconSrc?: string;
  /** InputFieldIcon from our library. */
  iconName?: IconName;
  showBadge?: boolean;
  badgeIconName?: IconName;
  background?: BackgroundColors;
  size?: IconSize;
}> = ({
  iconSrc,
  iconName,
  showBadge = false,
  badgeIconName = 'premiumStar',
  background = 'primary99',
  size = 's16',
}) => {
  return (
    <S.Badge $src={iconSrc} $background={background} $size={size} data-testid="topic-icon">
      {iconName && !iconSrc && <Icon name={iconName} />}
      {showBadge && (
        <S.IconWrapper>
          <Icon name={badgeIconName} />
        </S.IconWrapper>
      )}
    </S.Badge>
  );
};
